import { getProfileIdModelUtil } from '../get-profile-id'
import { getIdReduxUtil } from '../../../modules/redux/utils/get-id'

function isOwnerModelUtil (instance, profile) {
  return (
    getProfileIdModelUtil(instance) === getIdReduxUtil(profile)
  )
}

export default isOwnerModelUtil
